import { render, staticRenderFns } from "./spike-commodity.vue?vue&type=template&id=83830eda&scoped=true&"
import script from "./spike-commodity.vue?vue&type=script&lang=js&"
export * from "./spike-commodity.vue?vue&type=script&lang=js&"
import style0 from "./spike-commodity.vue?vue&type=style&index=0&id=83830eda&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83830eda",
  null
  
)

export default component.exports